export default __webpack_public_path__ + "static/media/Background_00109.d6077f4b.png";